import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { CssBaseline } from '@material-ui/core';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import { theme } from '@/client/constants/cdc';
import { diseaseConfig } from './constants';
import Main from './main';
import Prize from './prize';
import Quiz from './quiz';
import Result from './result';

// extract disease id from path, e.g., '/disease-quiz-tb/', '/disease-quiz-nove-influenza-a/'
const diseaseId = window.location.pathname.split('/')[1].split('-').slice(2).join('-');
const config = diseaseConfig[diseaseId];
theme.palette.primary.main = config.primaryColor;
const muiTheme = createMuiTheme(theme);

if (module.hot) {
  module.hot.accept();
}

const diseases = Object.keys(diseaseConfig);

const DiseaseQuizRouter = () => (
  <Router>
    {diseases.map(id => (
      <Switch key={id}>
        <Route path={`/disease-quiz-${id}/quiz`}>
          <Quiz config={config} />
        </Route>
        <Route path={`/disease-quiz-${id}/result`}>
          <Result config={config} />
        </Route>
        <Route path={`/disease-quiz-${id}/prize`}>
          <Prize config={config} />
        </Route>
        <Route path={`/disease-quiz-${id}/`}>
          <Main config={config} />
        </Route>
      </Switch>
    ))}
  </Router>
);

render(
  <MuiThemeProvider theme={muiTheme}>
    <CssBaseline />
    <DiseaseQuizRouter />
  </MuiThemeProvider>,
  document.getElementById('root'),
);
